module.exports = __webpack_public_path__ + "static/ettercap-b0ebcfe199f2df53d95a19489a0e874e.jpeg";